export default __webpack_public_path__ + "static/media/truck_alert.079235eb.mp3";